export const REVENUECAT_ENTITLEMENT_ID = 'Nebula Maze Pro';

// App Store Connect product plus the matching RevenueCat Test Store product.
export const AD_FREE_PRODUCT_IDS = [
  'com.onesmo.nebulamaze.adfree.monthly',
  'monthly',
] as const;

export const TOKEN_PACKS = [
  { productId: 'nebula_tokens_3', tokens: 3 },
  { productId: 'nebula_tokens_6', tokens: 6 },
  { productId: 'nebula_tokens_10', tokens: 10 },
] as const;

export const isAdFreeProduct = (productId: string) =>
  AD_FREE_PRODUCT_IDS.includes(productId as (typeof AD_FREE_PRODUCT_IDS)[number]);

export const tokenQuantityForProduct = (productId: string) =>
  TOKEN_PACKS.find((pack) => pack.productId === productId)?.tokens ?? null;

